<template>
  <v-container
    class="fill-height"    
    fluid
  >
    <v-row
      justify="center"
    >
      <v-col
        cols="12"
        md="12"
      >
        <material-card
          color="red"
          title="Access denied"
          text="No permission"
        >
          <v-container class="py-0">
            <v-row>
              <v-col cols="12">
                <p>Please contact administrator for enquiries</p>
              </v-col>
            </v-row>
          </v-container>         
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    metaInfo () {
      return {
        title: 'Access Denied',
      }
    },
  }
</script>
